define(
    'viewmodels/secured/explorer/details/details - Copy',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",
        "providers/dataprovider",        
        "services/service.documents",
        "i19n!i19n/strings",
        "viewmodels/secured/explorer/results/columns",

        // load to ensure any event handlers are attached and ready to receive.
        "viewmodels/secured/explorer/details/tabs/preview/preview",
        "viewmodels/secured/explorer/details/tabs/details/details"
],
    function (ctx, ViewModel, dataProvider, documentsService, i19n, columns, preview, details) {
        
        var previewTabHtml = String.format("<i class='fa fa-file bigger-110'></i> {0} <img class='spinner invisible' src='content/images/spinner.gif' />", i19n.to.preview);
        var detailsTabHtml = String.format("<i class='fa fa-edit bigger-110'></i> {0} <img class='spinner invisible' src='content/images/spinner.gif' />", i19n.to.details);

        var vm = new ViewModel(
        {
            hasCodeBehind: true,
            i19n: i19n,

            selectedTab: ko.observable(),
            previouslySelectedTab: ko.observable(),
            checkedDocuments: ko.observableArray(),
            executingActions: ko.observableArray(),

            columns: columns,

            tabs: {                
                preview: new Tab("preview", previewTabHtml, "viewmodels/secured/explorer/details/tabs/preview/preview"),
                details: new Tab("details", detailsTabHtml, "viewmodels/secured/explorer/details/tabs/details/details"),
                actions: new Tab("actions", i19n.to.action, "viewmodels/secured/explorer/details/tabs/actions/actions")
            },
            isGuest: ko.observable(false)
        });

        ctx.onNavSearch.subscribe(function (data) {
            init();
        });
        ctx.onNavFavoriteFolder.subscribe(function (folder) {
            init();
        });
        ctx.onNavFavoriteSearch.subscribe(function (folder) {
            init();
        });
        ctx.onNavFavoriteDocument.subscribe(function (data) {
            init();
        });
        ctx.onNavFlagged.subscribe(function (data) {
            init();
        });
        ctx.onNavRecent.subscribe(function (data) {
            init();
        });
        ctx.onNavAllCheckedOut.subscribe(function (data) {
            init();
        });
        ctx.onNavMyCheckedOut.subscribe(function (data) {
            init();
        });
        ctx.onNavFolder.subscribe(function (data) {
            //vm.checkedDocuments([]);
            vm.eventBroker.trigger(vm, vm.config.events.explorer.results.kendoGridColumnManage, { isShow: true });
        });
        ctx.onNavFolderShowAll.subscribe(function (data) {
            vm.checkedDocuments([]);
        });
        ctx.onNavMyDeleted.subscribe(function (data) {
            init();
        });
        ctx.onNavAllDeleted.subscribe(function (data) {
            init();
        });

        ctx.onDocument.subscribe(function (document) {
            //console.warn(ctx.current);
            //console.warn(document);
            //console.warn(sessionStorage.__url_listValueId);

            if (document) {
                sessionStorage.__url_documentId = document.documentId;

                if (ctx.current.listValue) {
                    sessionStorage.__url = window.location.origin + "/#explorer/library-list/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_listValueId + "/" + sessionStorage.__url_folderId + "/" + sessionStorage.__url_documentId;
                } else {
                    sessionStorage.__url = window.location.origin + "/#explorer/library/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_folderId + "/" + sessionStorage.__url_documentId;
                }

                window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);
            } else {
                if (ctx.current.listValue) {
                    sessionStorage.__url = window.location.origin + "/#explorer/library-list/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_listValueId + "/" + sessionStorage.__url_folderId;
                } else {
                    sessionStorage.__url = window.location.origin + "/#explorer/library/" + sessionStorage.__url_libraryId + "/" + sessionStorage.__url_folderId;
                }

                window.history.pushState('', 'Explorer | fileplan', sessionStorage.__url);
            }

            if (document) {
                vm.tabs.preview.disabled(false);
                vm.tabs.details.disabled(false);

                if (preview.isActiveTab() || (!preview.isActiveTab() && !details.isActiveTab())) {
                    preview.isActiveTab(true);
                    details.isActiveTab(false);
                }
                else if (details.isActiveTab()) {
                    details.isActiveTab(true);
                    preview.isActiveTab(false);
                }

                preview.load(document);
                details.load(document);
            } else {
                preview.load(null);

                vm.checkedDocuments([]);   // release any checked documents

                if (!preview.isActiveTab() && !details.isActiveTab()) {
                    preview.isActiveTab(true);
                    details.isActiveTab(false);
                }

                if (vm.activeTabs().length == 3) {
                    vm.activeTabs.pop();

                    if (vm.previouslySelectedTab()) {
                        vm.selectedTab(vm.previouslySelectedTab());
                    } else {
                        vm.selectedTab(vm.tabs.preview);
                    }
                }
                
                vm.tabs.preview.disabled(true); // do not enable. will cause flicker
                vm.tabs.details.disabled(true);
            }
        });
        ctx.onReloadFolders.subscribe(function () {
            //vm.checkedDocuments([]);
        });
        ctx.onReloadResults.subscribe(function (data) {
            //vm.checkedDocuments([]);
        });
        ctx.onDocumentChecked.subscribe(function (data) {
            if (data.isChecked) {
                var isExist = vm.checkedDocuments.find(function (document) {
                    return document.documentId == data.document.documentId;
                    //return _.isEqual(checkedDocumentInfo, documentInfo);
                });
                if (!isExist) {
                    vm.checkedDocuments.push(data.document);
                }
            }
            else {
                vm.checkedDocuments.reject_(function (document) {
                    return document.documentId == data.document.documentId;
                    //return _.isEqual(checkedDocumentInfo, documentInfo);
                });
            }
        });

        vm.checkedDocuments.subscribe(function (newValue) {
            if (vm.checkedDocuments().length && vm.activeTabs().length == 2) {
                vm.previouslySelectedTab(vm.selectedTab());
                vm.activeTabs.push(vm.tabs.actions);
            }
            else if (!vm.checkedDocuments().length && vm.activeTabs().length == 3) {
                vm.activeTabs.pop();
                vm.selectedTab(vm.previouslySelectedTab());
            }

            if (vm.activeTabs().length == 3) {
                vm.selectedTab(vm.tabs.actions);
            }
        });

        vm.activate = function () {
            var self = this;

            self.isGuest(vm.session.role == 0 || vm.session.role == 1 ? true : false);

            init();
        };
        vm.attached = function () {
            preview.isActiveTab(true);
            details.isActiveTab(false);

            vm.selectedTab(vm.tabs.preview);
        };

        vm.activeTabs = ko.observableArray([vm.tabs.preview,vm.tabs.details]);
        vm.tabs.actions.disabled(false);
        vm.tabs.actions.label = ko.computed(function () {
            return String.format("<i class='fa fa-check bigger-110'></i> {0} <span class='badge badge-important'>{1}</span>", i19n.to.actions, vm.checkedDocuments().length);
        });
        vm.tabSelected = function (tab) {
            return ko.asyncCommand({
                canExecute: function (isExecuting) {
                    return !isExecuting && !tab.disabled();
                },
                execute: function (data, event, complete) {
                    switch (data) {
                        case vm.tabs.preview:
                            details.isActiveTab(false);
                            preview.isActiveTab(true);
                            preview.load(ctx.current.document);
                            
                            break;
                        case vm.tabs.details:
                            details.isActiveTab(true);
                            preview.isActiveTab(false);
                            details.load(ctx.current.document);

                            break;
                        default:
                            details.isActiveTab(false);
                            preview.isActiveTab(false);
                    }
          
                    vm.selectedTab(data);
                    vm.previouslySelectedTab(data);

                    complete();
                }
            });
        };
        vm.refresh = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
     
                if(preview.isActiveTab())
                    preview.refresh();
                if (details.isActiveTab())
                    details.refresh();

                complete();
            }
        });

        vm.eventBroker.on(vm, vm.config.events.explorer.results.kendoGridColumnManage, function (p) {
            if (p.isShow) {
                $("#columns").hide();
                $(".tabbable").show();
            } else {                
                $("#columns").show();
                $(".tabbable").hide();
            }
        });

        return vm;

        function init() {
            preview.load(null);

            vm.checkedDocuments([]);   // release any checked documents
            
            preview.isActiveTab(true);
            details.isActiveTab(false);

            if (vm.activeTabs().length == 3) {
                vm.activeTabs.pop();

                if (vm.previouslySelectedTab()) {
                    vm.selectedTab(vm.previouslySelectedTab());
                } else {
                    vm.selectedTab(vm.tabs.preview);
                }
            } else {
                vm.selectedTab(vm.tabs.preview);
            }

            vm.tabs.preview.disabled(true);
            vm.tabs.details.disabled(true);
        }        

        function Tab(name, label, module, data) {
            var self = this;

            self.name = name;
            self.label = ko.observable(label);
            self.module = ko.observable(module);
            self.data = ko.observable(data);
            self.disabled = ko.observable(false);
            self.isBusy = ko.observable(false);
            self.activeModule = ko.computed(function () {
                return self.disabled() ? "viewmodels/secured/explorer/details/noDocument" : self.module();
            });

            self.isBusy.subscribe(function (newValue) {
                self.label(newValue === true && label ? label.replace(" invisible", "") : label);
            });
        }
});
